import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Stack, Tooltip, IconButton as MuiIconButton } from "@mui/material";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CachedIcon from "@mui/icons-material/Cached";
import TroubleshootIcon from "@mui/icons-material/Troubleshoot";

import RegionTable from "../../../components/pages/super/region/T_Region";
import RegionModal from "../../../components/pages/super/region/M_Region";
import TestRegionModal from "../../../components/pages/super/region/M_TestRegion";
import useAuth from "../../../hooks/useAuth";
import useRegion from "../../../hooks/super/useRegion";
import { UserType } from "../../../utils/constants";

import { CollapseAlert } from "../../../components/pages/common/styled";
import PageHeader from "../../../components/pages/_new/super/common/PageHeader";
import PrimaryButton from "../../../components/pages/_new/super/common/PrimaryButton";
import OutlinedButton from "../../../components/pages/_new/super/common/OutlinedButton";
import colors from "../../../utils/colors";

function SARegionList({ type }) {
  const { getRegions, size, errMsg, setErr } = useRegion();
  const { isAuthenticated, adminUserType } = useAuth();

  const [errOpen, setErrOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [testOpen, setTestOpen] = React.useState(false);
  const testHandleOpen = () => setTestOpen(true);
  const testHandleClose = () => setTestOpen(false);

  const testClick = async () => {
    testHandleOpen();
  };

  const refresh = () => {
    getRegions(size, 0);
  };

  React.useEffect(() => {
    if (isAuthenticated) getRegions(size, 0);
    return () => setErr(null);
  }, [isAuthenticated, getRegions, size, setErr]);
  React.useEffect(() => {
    if (errMsg) setErrOpen(true);
  }, [errMsg]);

  return (
    <React.Fragment>
      <Helmet title={"SA Regions"} />
      <PageHeader
        title="Region List"
        description="Manage geographical regions for WAF deployment"
        actions={
          <>
            <Tooltip title="Test All Regions">
              <MuiIconButton
                onClick={testClick}
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: "8px",
                  border: `1px solid ${colors.primary[300]}`,
                  color: colors.primary[300],
                  "&:hover": {
                    backgroundColor: "rgba(99, 113, 247, 0.08)",
                    borderColor: "#4959ee",
                    color: "#4959ee",
                  },
                }}
              >
                <TroubleshootIcon style={{ width: 20, height: 20 }} />
              </MuiIconButton>
            </Tooltip>
            <OutlinedButton
              onClick={refresh}
              startIcon={<CachedIcon style={{ width: 20, height: 20 }} />}
            >
              Refresh
            </OutlinedButton>
            <PrimaryButton
              onClick={handleOpen}
              startIcon={<AddCircleOutlineIcon style={{ width: 20, height: 20 }} />}
              disabled={![UserType.SUPER_ADMIN].includes(adminUserType)}
            >
              Add Region
            </PrimaryButton>
          </>
        }
      />
      <Box sx={{ mb: 4 }}>
        <CollapseAlert errOpen={errOpen} setErrOpen={setErrOpen} setErr={setErr} errMsg={errMsg} />
      </Box>
      <Stack spacing={4}>
        <RegionTable type={type} />
      </Stack>
      <RegionModal type={type} open={open} handleClose={handleClose} />
      <TestRegionModal open={testOpen} handleClose={testHandleClose} region={null} loading={false} />
    </React.Fragment>
  );
}
export default SARegionList;
